import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import { Footer } from '@/components/Footer/Footer';
import { PageLoader } from '@/components/PageLoader/PageLoader';
import { ItineraryProvider } from '@/context/ItineraryContext';
import { ModalProvider } from '@/context/modal';
import { useItinerary } from '@/handlers/useItinerary';
import { useDelayedState } from '@/hooks/useDelayedState';

import { AppWrapper, ContentWrapper } from './styles';

import { GlobalStyle } from '../../styles/GlobalStyle';
import { theme } from '../../styles/theme';

export function App() {
  const itinerary = useItinerary();

  // Delayed unmount for page loader
  const DELAYED_UNMOUNT_TIME = 1000;
  const [delayedUnmount, setDelayedUnmount] = useDelayedState(itinerary.isLoading, DELAYED_UNMOUNT_TIME);
  useEffect(() => {
    setDelayedUnmount(itinerary.isLoading);
  }, [itinerary.isLoading, setDelayedUnmount]);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <ItineraryProvider value={itinerary}>
        <ModalProvider>
          <AppWrapper>
            <ContentWrapper>
              {delayedUnmount && <PageLoader animateOut={!itinerary.isLoading} animateOutTime={DELAYED_UNMOUNT_TIME} />}
              {!itinerary.isLoading && <Outlet />}
            </ContentWrapper>
            <Footer />
          </AppWrapper>
        </ModalProvider>
      </ItineraryProvider>
    </ThemeProvider>
  );
}
